import clsx from "clsx";
import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

/** Scrollable page with a title and optional sub-navigation tabs. */
export default function PageShell({ title, tabs, children }: { title: string; tabs?: { to: string; label: string }[]; children: ReactNode }) {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="mx-auto max-w-4xl px-4 py-6 md:px-8">
        <h1 className="mb-4 pl-10 text-2xl font-semibold md:pl-0">{title}</h1>
        {tabs && (
          <nav className="mb-6 flex gap-1 overflow-x-auto border-b border-zinc-200 dark:border-zinc-800">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end
                className={({ isActive }) =>
                  clsx(
                    "-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm",
                    isActive ? "border-indigo-600 font-medium" : "border-transparent text-zinc-500 hover:text-zinc-900 dark:hover:text-zinc-100",
                  )
                }
              >
                {t.label}
              </NavLink>
            ))}
          </nav>
        )}
        <div className="space-y-6">{children}</div>
      </div>
    </div>
  );
}
